import styled from 'styled-components'
import { em, math } from 'polished'

export const Container = styled.div`
  height: ${p => p.theme.blocks.menuHeight};

  ${p => p.theme.mq.upMd} {
    height: ${({ theme, withExtraIndent, indentHeight }) =>
      withExtraIndent
        ? indentHeight?.md
          ? math(`${em(indentHeight.md)} + ${theme.blocks.menuHeightMd}`)
          : theme.blocks.menuHeightX2Md
        : theme.blocks.menuHeightMd};
  }

  ${p => p.theme.mq.upLg} {
    height: ${({ theme, withExtraIndent, indentHeight }) =>
      withExtraIndent
        ? indentHeight?.lg
          ? math(`${em(indentHeight.lg)} + ${theme.blocks.menuHeightMd}`)
          : theme.blocks.menuHeightX2Md
        : theme.blocks.menuHeightMd};
  }
`
